<template>
  <span>
    {{ counterWithTimeFormat }}
  </span>
</template>

<script>
import { computed, defineComponent } from "vue";
import { useStore } from "vuex";
import moment from "moment-timezone";

import { dateTimeToTime, timeStringToSeconds, secondsToTimeString } from "@/app/shared/utils/dates";

export default defineComponent({
  props: {
    record: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const store = useStore();

    const timezone = computed(() => store.getters["getDataUser"]?.customer?.timezone);
    const hourPlatform = computed(() => store.getters["getHourPlatform"]);

    const startTime = computed(() => {
      const formattedTime = moment(props.record?.updated_at)
        ?.tz(timezone.value)
        ?.format("DD/MM/YYYY HH:mm:ss");

      return dateTimeToTime(formattedTime) || "00:00:00";
    });

    const counterInSeconds = computed(
      () => timeStringToSeconds(hourPlatform.value) - timeStringToSeconds(startTime.value)
    );

    const counterWithTimeFormat = computed(() => secondsToTimeString(counterInSeconds.value || 0));

    return { counterWithTimeFormat };
  },
});
</script>

<style lang="sass" scoped></style>
